import type { IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageUpdatedNewGlobal } from 'entities/Conversation/events/EventMessageUpdatedNewGlobal'

export const useEventMessageUpdatedNewLog = () => {
  const { dataLogStore } = useEntitiesContext()

  const handler = (data: IResponseEventMessage) => {
    const { message, conversation, trace_payload } = data

    dataLogStore.setItem({
      logLevel: 'info',
      message: 'EventMessageUpdatedNew',
      details: {
        conversationId: conversation.id,
        messageId: message.id,
        traceId: trace_payload?.trace_id,
      },
    })
  }

  useEventMessageUpdatedNewGlobal(handler)
}
